interface ParseNumberOptions {
  fallback: number;
}

export const parseNumber = (input: string, { fallback }: ParseNumberOptions): number => {
  const result = Number(input);

  return Number.isNaN(result) ? fallback : result;
};
